import { render, staticRenderFns } from "./ManageHoliday.vue?vue&type=template&id=44d051b5"
import script from "./ManageHoliday.vue?vue&type=script&lang=ts"
export * from "./ManageHoliday.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports